@if (viewAllRoles && viewAllRoleDetails != null) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div
      class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-0 top-0 left-0 right-0 p-5 text-left">
      <div class="flex justify-between">
        User: {{viewAllRoleDetails.display_name}} role(s)
        <button (click)="closeRoleDetails()"
          class="hover:bg-gray-200 rounded-full p-0.5 w-8 h-8 flex justify-center items-center"
          aria-label="Close Role Details">
          <fa-icon [icon]="faXmark" />
        </button>
      </div>
      <hr class="my-1 -mx-5 mt-2" />
      <div class="max-h-80 overflow-y-auto">
        @for (role of viewAllRoleDetails.roles; track role; let i = $index) {
        <div
          [ngClass]="i % 2 === 0? 'flex justify-between items-center mt-2 p-2 rounded-[8px]': 'flex justify-between items-center mt-2 p-2 rounded-[8px] bg-gray-100'">
          <div>
            {{role.role_name}}
            <div class="text-xs text-slate-500">
              {{role.organization_name != undefined? 'Organization: ' + role.organization_name: ''}} {{role.subject_name
              != undefined? 'Subject: ' + role.subject_name: ''}} {{role.unit_name != undefined? 'Unit: ' +
              role.unit_name: ''}} {{role.course_name != undefined? 'Course: ' + role.course_name: ''}}
            </div>
          </div>
          <full-button (click)="removeRole(role)" text="Remove" />
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
@if (openAddRoleDialog) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div
      class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-0 top-0 left-0 right-0 p-5 text-left">
      <!-- TODO add a tree filter that starts at org level and narrows down the tree -->
      <p class="font-bold z-10 mt-2">Add new role</p>
      <dropdown-search [getRoleDetails]="true" [items]="userRoles" [addedList]="addedTempUserRole"
        [singleItemList]="true" placeholder="Search for roles" class="mt-2" />
      @if (addedTempUserRole.length > 0) {
      <div>
        @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0 ||
        addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
        <p class="text-sm mt-2">
          Add <b>only one</b> of the four contexts from below. The contexts work top down, meaning if you assign a role
          at the organization level they will also have that role for each context (the subjects, units, and courses)
          that reside underneath it.
          <br /><br />
          The contexts reside underneath each other in this order. organization > subject > unit > course.
        </p>
        }
        @if (addedTempUserRole[0].organizations != null && addedTempUserRole[0].organizations.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Organizations</p>
          <dropdown-search
            [disabled]="addedCourseList.length > 0 || addedSubjectList.length > 0 || addedUnitList.length > 0"
            [items]="addedTempUserRole[0].organizations" [addedList]="addedOrgList" [singleItemList]="true"
            [isOrganization]="true" placeholder="Choose organizations" />
        </div>
        }
        @for (org of addedOrgList; track org; let i = $index) {
        <chip [text]="org.organization_name != undefined? org.organization_name: ''"
          (click)="this.addedOrgList.splice(i, 1)" />
        }
        @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Subjects</p>
          <dropdown-search
            [disabled]="addedOrgList.length > 0 || addedCourseList.length > 0 || addedUnitList.length > 0"
            [items]="addedTempUserRole[0].subjects" [addedList]="addedSubjectList" [singleItemList]="true"
            [isSubject]="true" placeholder="Choose subjects" />
        </div>
        }
        @for (org of addedSubjectList; track org; let i = $index) {
        <chip [text]="org.subject_name != undefined? org.subject_name: ''"
          (click)="this.addedSubjectList.splice(i, 1)" />
        }
        @if (addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Units</p>
          <dropdown-search
            [disabled]="addedOrgList.length > 0 || addedCourseList.length > 0 || addedSubjectList.length > 0"
            [items]="addedTempUserRole[0].units" [addedList]="addedUnitList" [singleItemList]="true" [isUnit]="true"
            placeholder="Choose units" />
        </div>
        }
        @for (org of addedUnitList; track org; let i = $index) {
        <chip [text]="org.unit_name != undefined? org.unit_name: ''" (click)="this.addedUnitList.splice(i, 1)" />
        }
        @if (addedTempUserRole[0].courses != null && addedTempUserRole[0].courses.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Courses</p>
          <dropdown-search
            [disabled]="addedOrgList.length > 0 || addedUnitList.length > 0 || addedSubjectList.length > 0"
            [items]="addedTempUserRole[0].courses" [addedList]="addedCourseList" [singleItemList]="true"
            [isCourse]="true" placeholder="Choose courses" />
        </div>
        }
        @for (org of addedCourseList; track org; let i = $index) {
        <chip [text]="org.course_name != undefined? org.course_name: ''" (click)="this.addedCourseList.splice(i, 1)" />
        }
      </div>
      }
      <div class="flex justify-end mt-4">
        <outline-button [marginRight]="true" (click)="cancelAddRole()" text="Cancel" />
        <full-button (click)="saveNewRole()" text="Save Role configuration" />
      </div>
    </div>
  </div>
</div>
}
@if (activateDeactivateConfirmationDialog && activateDeactivateConfirmationUser != null) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div
      class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-[40%] left-0 right-0 p-5 text-center">
      <p class="font-bold z-10 my-3">Are you sure you want to {{activateDeactivateConfirmationUser.active? 'deactivate':
        'activate'}} {{activateDeactivateConfirmationUser.display_name}}?</p>
      @if (activateDeactivateConfirmationUser.active) {
      <p class="mb-3">Doing so will revoke access to the system for this user</p>
      }
      @if (!activateDeactivateConfirmationUser.active) {
      <p class="mb-3">Doing so will grant access to the system for this user</p>
      }
      @if (activateDeactivateConfirmationUser.user_id != null) {
      <div class="flex justify-end">
        <outline-button [marginRight]="true" (click)="activateDeactivateConfirmationDialog = false" text="Cancel" />
        <full-button
          (click)="setActive(activateDeactivateConfirmationUser.user_id, !activateDeactivateConfirmationUser.active)"
          text="Confirm" />
      </div>
      }
    </div>
  </div>
</div>
}
<breadcrumb endText="All Users" [navigations]="breadcrumbNavs" />
<div class="m-8">
  <h1 class="font-semibold text-xl">
    All Users
  </h1>
  <div class="flex flex-row justify-between my-4">
    <div class="flex items-center">
      <search-input [(searchText)]="searchText" (searchTextChange)="debounceSearch()"
        placeholder="Search by name or net id" containerClass="lg:w-80 mr-3" />
      <button type="button" role="switch" [attr.aria-checked]="showDeactivatedUsers" (click)="toggleDeactivatedUsers()"
        class="flex items-center gap-3 h-[42px] px-4 rounded-[8px] border border-[#919EAB80] bg-white text-sm text-[#637381] hover:bg-[#F4F6F8] transition">
        <span class="relative inline-flex h-5 w-9 shrink-0 rounded-full transition-colors"
          [ngClass]="showDeactivatedUsers ? 'bg-rutgers-red' : 'bg-[#C4CDD5]'">
          <span class="absolute top-0.5 left-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform"
            [ngClass]="showDeactivatedUsers ? 'translate-x-4' : 'translate-x-0'"></span>
        </span>
        Show deactivated users
      </button>
    </div>
    <outline-button [faIcon]="faAdd" text="Add User" (click)="addUser()" />
  </div>
  <table class="w-full lg:table-fixed border-separate border-spacing-0">
    <colgroup>
      <col class="lg:w-[560px]" />
      @if (showDeactivatedUsers) {
      <col class="w-[120px]" />
      }
      <col class="hidden lg:table-column lg:w-[180px]" />
      <col class="hidden lg:table-column" />
      <col class="w-[72px]" />
    </colgroup>
    <thead>
      <tr class="h-[48px] text-left text-gray-500 text-xs font-semibold uppercase leading-tight">
        <th scope="col" class="bg-[#F4F6F8] rounded-l-[4px] pl-[16px] pr-2 font-semibold">
          Name
        </th>
        @if (showDeactivatedUsers) {
        <th scope="col" class="bg-[#F4F6F8] px-2 font-semibold">
          Status
        </th>
        }
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold">
          NetID
        </th>
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold">
          Role(s)
        </th>
        <th scope="col" class="bg-[#F4F6F8] rounded-r-[4px] pl-2 pr-[16px]">
          <span class="sr-only">Actions</span>
        </th>
      </tr>
    </thead>
    <tbody class="transition-opacity" [class.opacity-50]="isLoading && users.length > 0">
      @for (user of users; track user) {
      <tr class="hover:bg-[#F9FAFB] transition-colors">
        <td class="pl-[16px] pr-2 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          <button type="button" (click)="profile(user.email)"
            class="block max-w-full truncate text-left font-medium text-black/90 hover:text-rutgers-red hover:underline">
            {{user.display_name}}
          </button>
          <div class="truncate text-xs text-gray-500">{{user.email}}</div>
        </td>
        @if (showDeactivatedUsers) {
        <td class="px-2 py-3 align-middle border-b border-[#F1F3F5]">
          @if (user.active) {
          <span class="inline-flex items-center rounded-full bg-[#DBF6E5] px-2 py-0.5 text-xs font-medium text-[#118D57]">
            Active
          </span>
          } @else {
          <span class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
            Deactivated
          </span>
          }
        </td>
        }
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm text-gray-600 truncate">
          {{user.username}}
        </td>
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          @if (user.roles) {
          @let roles = roleList(user.roles);
          <div class="flex items-center gap-1.5 min-w-0" [tooltip]="user.roles">
            <span class="truncate text-black/90">{{roles[0]}}</span>
            @if (roles.length > 1) {
            <span class="shrink-0 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
              +{{roles.length - 1}}
            </span>
            }
          </div>
          } @else {
          <span class="text-gray-500">No role</span>
          }
        </td>
        <td class="pl-2 pr-[16px] py-3 align-middle border-b border-[#F1F3F5]">
          <div class="flex items-center justify-center">
            @if (user.menuItems != null) {
            <dropdown-menu [menuItems]="user.menuItems" aria-label="User Menu" appearance="outlined" />
            }
          </div>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="5" class="py-10 text-center text-sm text-gray-500">
          @if (isLoading) {
          <div class="flex justify-center">
            <dot-spinner />
          </div>
          } @else if (searchText) {
          No users match "{{searchText}}"
          } @else {
          No users found
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
  <full-length-pagination [(currentPagination)]="currentPagination" perPageText="Users"
    (paginationService)="handleServiceCall()" />
</div>
